import { Controller } from 'react-hook-form'
import * as z from 'zod'

import { ScoreRadio } from '~/@mid_ui-form/score-radio/ScoreRadio'
import { ScoreRadioGroup } from '~/@mid_ui-form/score-radiu-group/ScoreRadioGroup'
import { FormStep } from '~/@pages_onboarding/investor-analysis/_analysis-form/FormStep'
import { StepTitle } from '~/@pages_onboarding/investor-analysis/_analysis-form/StepTitle'
import { useFormStepUnsophisticated } from '../../form-step-unsophisticated/useFormStepUnsophisticated'
import { useQuestionsV1 } from '../../../questions'

const step1Schema = z.object({
  financialStability: z.object({
    value: z.enum([
      'lowCapitalPreferLowLosses',
      'moderateFinancialStabilityCanBearLimitedLosses',
      'highFinancialStabilityWillingToAcceptSignificantLosses',
    ]),
    score: z.number(),
  }),
})

export type Step1Data = z.infer<typeof step1Schema>

export function Step1() {
  const { onStepCompleted, formData } = useFormStepUnsophisticated()
  const { unsophisticated: unsophisticatedQuestions } = useQuestionsV1()

  return (
    <FormStep
      defaultValues={formData}
      schema={step1Schema}
      onStepCompleted={onStepCompleted}
      render={({ control }) => (
        <>
          <StepTitle>
            {unsophisticatedQuestions.financialStability.question.label}
          </StepTitle>
          <Controller
            control={control}
            name="financialStability"
            render={({ field }) => (
              <ScoreRadioGroup
                value={field.value}
                onValueChange={field.onChange}>
                {Object.entries(
                  unsophisticatedQuestions.financialStability.answers
                ).map(([value, answer]) => (
                  <ScoreRadio
                    key={value}
                    score={answer.score}
                    value={value}
                    label={answer.label}
                  />
                ))}
              </ScoreRadioGroup>
            )}
          />
        </>
      )}
    />
  )
}
